import { FormUnit, FoodsIconButton } from "@foodpilot/foods";
import { Stack, useTheme } from "@mui/material";
import { usePropertyContext } from "../../../context/usePropertyContext";
import { MultiPropertyGroup } from "../../../context/utils/computeElementsGroup";
import { MultiElementsRow } from "../MultiElementsRow";
import { useTranslation } from "react-i18next";
import { ItemTag } from "../ItemTag";

type MultiElementsGroupProps = {
    elementGroup: MultiPropertyGroup;
    deleteElement: (position: number) => void;
    showSubscore?: boolean | undefined;
    level?: number;
    itemNb: number;
};

export const MultiElementsGroup = (props: MultiElementsGroupProps) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { itemNb, deleteElement, elementGroup } = props;
    const { canEdit, scoreUnit } = usePropertyContext();

    return (
        <Stack borderRadius="8px" gap={theme.spacing(3)}>
            <Stack flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"}>
                <ItemTag itemNb={itemNb} />
                <Stack flexDirection={"row"} gap={theme.spacing(1)}>
                    {elementGroup.multivalueLabel && elementGroup.shouldDisplayScore && (
                        <FormUnit value={elementGroup.multivalueLabel} unit={scoreUnit} />
                    )}
                    {canEdit && (
                        <FoodsIconButton
                            size={"s"}
                            icon={"delete"}
                            withBackground
                            buttonProps={{
                                sx: {
                                    "&:hover": {
                                        backgroundColor: "rgba(238, 60, 21, 0.04)",
                                    },
                                    border: `1px solid #EE3C15`,
                                    color: `#EE3C15`,
                                },
                                onClick: () => deleteElement(elementGroup.position),
                            }}
                        />
                    )}
                </Stack>
            </Stack>
            {elementGroup.propertiesData.map((propertyData) => {
                return (
                    <Stack key={`index-coucou-${propertyData.property.id}`} direction="column" gap="8px">
                        <MultiElementsRow propertyData={propertyData} elementGroup={elementGroup} level={props.level} />
                    </Stack>
                );
            })}
        </Stack>
    );
};
